export default "__VITE_ASSET__k3dNhleY__"